module.exports = __webpack_public_path__ + "img/cuff_spec_elastic_length.e8bf7c7a.png";